import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRenderStore } from 'stores/render';
import handleError from 'src/helpers/handleError';
import { useAutoresponderStore } from 'stores/autoresponder';
import { useRoute } from 'vue-router';
import { useQuasar } from 'quasar';

export default () => {
  const renderStore = useRenderStore();
  const autoresponderStore = useAutoresponderStore();
  const route = useRoute();
  const $q = useQuasar();

  const isPostPage = computed(() => route.params.postSlug !== undefined);
  const mobileMenuRef = ref(null);

  const {
    post,
    settings,
    anchors,
    posts,
    showEmailSubscribeDialog,
    emailForSubscribe,
  } = storeToRefs(renderStore);

  const banner = computed(() => settings.value.metaFields.banner?.imageGuid?.url);
  const postsForColumn = computed(() => posts.value.shift());
  const firstPost = computed(() => posts.value[0]);

  function scrollTo(element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }

  async function onSubscribe(emailToSubscribe) {
    try {
      emailForSubscribe.value = emailToSubscribe;
      const ownerEntryType = isPostPage.value ? post.value.entryKey : 'blogEntries';
      const ownerEntryGuid = post.value?.guid || settings.value.guid;
      await autoresponderStore.addLead({
        email: emailToSubscribe,
        ownerEntryType,
        ownerEntryGuid,
      });
      showEmailSubscribeDialog.value = true;
    } catch (error) {
      handleError(error);
    }
  }

  const logo = computed(() => settings.value.metaFields.logoGuid?.url || '/logo-default.png');
  const isMobile = computed(() => ($q.platform.is.mobile));
  const isSmallScreen = computed(() => ($q.platform.is.mobile || $q.screen.width <= 1024));

  const FOOTER_LOGO_WIDTH = 70;

  const logoAspectRatio = computed(() => {
    const { width, height } = settings?.value?.metaFields?.logoGuid?.attributes || { width: 0, height: 0 };
    return width / height;
  });

  const headerLogoAttributes = computed(() => calculateLogoAttributes(isSmallScreen.value ? 80 : 150));
  const footerLogoAttributes = computed(() => calculateLogoAttributes(FOOTER_LOGO_WIDTH));

  function calculateLogoAttributes(logoWidth) {
    return {
      width: `${logoWidth}px`,
      height: `${Math.round(logoWidth / logoAspectRatio.value)}px`,
    };
  }

  return {
    mobileMenuRef,
    banner,
    anchors,
    scrollTo,
    onSubscribe,
    logo,
    settings,
    headerLogoAttributes,
    footerLogoAttributes,
    posts,
    postsForColumn,
    firstPost,
    isPostPage,
    isMobile,
    isSmallScreen,
  };
};
